<template>
<section class="emails">
<main class="contenedor">
  <div class="contentCenter all">
    <div class="row">
<div class="col-md-2">
  <div>
  <span>Price per captcha <i class="icon-dollar"></i> 0.0072 usd.</span>
  </div>

<div>
  DONE TODAY
</div>
<div v-if="emaildone != undefined">
  <span v-if="currentUser.id == 91 && emaildone != undefined">
     {{emaildone.today}}
  </span>
  <span v-if="currentUser.id != 91 && emaildone != undefined">
     {{emaildone.today}}
  </span> x 0,0072 = <span class="text-success"> <i class="icon-dollar"></i> {{getCalculationDone(emaildone.today)}} usd </span>
</div>
  

<div>
  DONE CURRENT MONTH
</div>
<div v-if="emaildone != undefined">
  <span v-if="currentUser.id == 91 && emaildone != undefined">
     {{emaildone.current_month}}
  </span>
  <span v-if="currentUser.id != 91 && emaildone != undefined">
     {{emaildone.current_month}}
  </span> x 0,0072 = <span class="text-success"> <i class="icon-dollar"></i> {{getCalculationDone(emaildone.current_month)}} usd </span>
  
</div>


  <span v-if="emaildone == undefined">
     Loading...
  </span>
  
  <ul  v-if="false" style="height: 500px;overflow:scroll;">
  <li  @click="open(email.client_nylas_id,email.email)" class="cursor-pointer bg-success my-1 text-white p-2" v-for="email in emaildone">{{email.updated}}</li>
</ul>
</div>
    <span v-if="!unLockScreen()" class="text-danger">
      The hours for sending emails are from 8 a.m. to 6 p.m. France.<br>
      You must wait for the schedule to start working.
    </span>
      <div class="col-md-10" v-if="unLockScreen()">
    <LoadingSpinner v-if="loading"/>
    <div v-if="email === undefined && !loading">EMPTY</div>
    <button @click="refresh()" class="btn btn-primary">REFRESH</button>
    <div class="table-responsive" v-if="email && !loading">
    <h4 v-if="email.cant > 40">Pending: {{getCant(email.cant)}}</h4>
    <h4 class="text-primary" v-else>Pending: {{email.cant}}</h4> 
    <button id="clickNext-oliverlist" class="btn btn-primary" @click="nextEmail()">NEXT</button> 
    <div  v-if="email.body !== undefined">
    <div class="mt-4" v-if="false"> 
     <label>{{email.subject}}</label>
    </div>
    <div class="mt-1" v-if="false">
     <label>{{getdate(email.date)}}</label>
    </div>
    <div class="mt-1" v-if="false">
     From: <strong class="mr-1">{{email.from[0].name}}</strong> <label>{{email.from[0].email}}</label>

    </div>
    <div class="mt-1" v-if="false">
     To: <strong class="mr-1">{{email.to[0].name}}</strong> <label>{{email.to[0].email}}</label>

    </div>
    <p v-show="false" v-html="quoted_printable_decode(email.body)" class="email-body">{{  email.body }}</p>
    </div>
    <div v-else> ERROR {{email}}</div>
  </div>
</div>
  </div>
</div>
</div>
</div>
</main>
</section>
</template>

<script>

  import { mapState, mapActions } from "vuex";
  import { router } from "@/_helpers";
  import { statusBadgeMixin } from "@/_mixins/";
  import { emailsService, usersService } from "@/_services";
  import Header from "@/components/Header.vue";
  import LoadingSpinner from "@/components/LoadingSpinner.vue";
  import moment from "moment";

  export default {
   data() {
    return {
      currentPage: 1,
      cantPerPage: 50,
      email:false,
      loading:false,
      emaildone:[]
    };
  },


  components: {
    LoadingSpinner
  },

  computed: {
    ...mapState({
      currentUser: state => state.authentication.user
    }),
},
props: {
  clientId: String
},
created() {
  this.loadNewEmail()
  this.loadEmailList()
},
methods: {
  unLockScreen(){
  return true;
    var today = new Date();
    return (today.getHours() <= 18 && today.getHours() >= 7)
  },
  getCant(cant){
    return cant;
  },
  getCalculationDone(done){
      let cant = 0
      if(this.currentUser.id == 91){
        cant = done
      }else{
        cant = done
      }

        return Math.round(cant*0.0072)
      
  },
  getEmailDone(){
    let birthday = new Date();
    let hour = birthday.getHours();
    if(hour < 8){
      return 35
    }
    if(hour == 8){
      return 150
    }
    if(hour == 9){
      return 350
    }
    if(hour == 10){
      return 478
    }
    if(hour == 11){
      return 589
    }
    if(hour > 11){
      return 655
    }
  },
  quoted_printable_decode (str) { // eslint-disable-line camelcase
  
   
   if(str && str.indexOf('=E9') && !str.indexOf('http'))  {


    var RFC2045Decode1 = /=\r\n/gm
    // the RFC states against decoding lower case encodings, but following apparent PHP behavior
    var RFC2045Decode2IN = /=([0-9A-F]{2})/gim
    var RFC2045Decode2OUT = function (sMatch, sHex) {
      return String.fromCharCode(parseInt(sHex, 16))
    }

    str = str.replace(RFC2045Decode1, '')
      .replace(RFC2045Decode2IN, RFC2045Decode2OUT)


   }



    str = str.replace('<a','<a target="_blank"');

    if(!this.mailinblack(str)){
        if(!this.humail(str)){
          if(!this.spamenmoins(str)){
            if(!this.buzzee(str)){
              if(!this.authentimail(str)){
                if(!this.authentimail2(str)){
                  
                } 
              } 
            } 
          } 
        } 
    }
    return str;
  }, 
  mailinblack(text) {
    //var urlRegex = /(((https:(.*)invitation))[^\s]+)/g;
    
    var urlRegex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?invitation.*?)\1/g;
    var urlRegex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?invitation.*?)\1/g;


    var match;
    while (match = urlRegex.exec(text)) {
      var url = match[2]; // Extrae solo el contenido de la URL
    }

    if(url !== undefined && url.indexOf("no-robot") > 0){
      url = url.replace('"','');
      url = url.replace('/>','');
      if(this.currentUser.id != 91){
        url = url.replace('lang=fr','lang=es')
      }
      url = url.replace('&amp;','&');
      window.open(url, '_blank');
      return true;
    }

    if(match !== null){
      match.forEach(result => {
          var url = result;
          if(url.indexOf("no-robot") > 0){
            url = url.replace('"','');
            url = url.replace('/>','');
            if(this.currentUser.id != 91){
              url = url.replace('lang=fr','lang=es')
            }
            url = url.replace('&amp;','&');
            window.open(url, '_blank');
            return true;
          }
      })
    }
    return false;
  },
  spamenmoins(text) {
    var urlRegex = /(((https:\/\/antispam.spamenmoins))[^\s]+)/g;
    //var urlRegex = /(https?:\/\/[^\s]+)/g;
    var match = text.match(urlRegex)
    if(match !== null){
      if(match[1] == undefined && match[0] !== undefined ){
        var url = match[0];
      }else{
        var url = match[1];
      }
      if(url !== undefined){
        url = url.replace('"','');
        url = url.replace('&amp;','&');
        window.open(url, '_blank');
      }
      return true;
    }
    return false;
  },
  authentimail(text) {
    var urlRegex = /(((https:\/\/www.authenti-mail.com))[^\s]+)/g;
    //var urlRegex = /(https?:\/\/[^\s]+)/g;
    var match = text.match(urlRegex)
    if(match !== null && match[1] !== undefined){
      var url = match[1];
      url = url.replace('"','');
      url = url.replace('&amp;','&');
      window.open(url, '_blank');
      return true;
    }
    return false;
  },
  authentimail2(text) {
    var urlRegex = /(((https:\/\/www.authentimails.com))[^\s]+)/g;
    //var urlRegex = /(https?:\/\/[^\s]+)/g;
    var match = text.match(urlRegex)
    if(match !== null && match[1] !== undefined){
      var url = match[1];
      url = url.replace('"','');
      url = url.replace('&amp;','&');
      window.open(url, '_blank');
      return true;
    }
    return false;
  },
  humail(text) {
    var urlRegex = /(((https:\/\/humail))[^\s]+)/g;
    //var urlRegex = /(https?:\/\/[^\s]+)/g;
    var match = text.match(urlRegex)
    if(match !== null){
      var url = match[1];
      url = url.replace('"','');
      url = url.replace('&amp;','&');
      window.open(url, '_blank');
      return true;
    }
    return false;
  },
  buzzee(text) {
    var urlRegex = /(((https:\/\/www.crm-buzzee))[^\s]+)/g;
    //var urlRegex = /(https?:\/\/[^\s]+)/g;
    var match = text.match(urlRegex)
    if(match !== null){
      var url = match[1];
      url = url.replace('"','');
      url = url.replace('&amp;','&');
      window.open(url, '_blank');
      return true;
    }
    return false;
  },
  nextEmail(){
      this.loading = true
      emailsService.emailDone(this.email.email_id).then(r => {
        this.loadNewEmail()
      });
      this.loadEmailList()
  },
  loadNewEmail(){
    emailsService.getNylasEmails(null,1,100).then(
      result => { 
        this.email = result
        if(this.email.from === undefined && result[0] !== undefined){
          this.email = result[0]
        }
        this.loading = false
      }
    );
  },
  open(client_nylas_id,emailkey){
    emailsService.getNylasEmail(client_nylas_id,emailkey).then(
      result => { 
        this.email = result
        if(this.email.from === undefined){
          this.email = result[0]
        }
        this.loading = false
      }
    );
  },
  refresh(){
    this.loadNewEmail()
    this.loadEmailList()
  },
  loadEmailList(){
    emailsService.getNylasEmailsList(1).then(
      result => { 
          this.emaildone = result[0]
      }
    );
  },
  getdate(dt){
    let timst = moment.unix(dt)
    return timst;
  }
}

};
</script>